import React from "react";
import { useApp } from "../context/AppContext";
import { Copy, MessageCircle, Send, Check } from "lucide-react";

const ShareButtons = ({ product }) => {
  const { lang, settings } = useApp();
  const [copied, setCopied] = React.useState(false);
  const name = product[`name_${lang}`] || product.name_en;
  const url = typeof window !== "undefined" ? window.location.href : "";
  const text =
    lang === "id"
      ? `Lihat ${name} dari Holy Flowy 🎄✨\nHandmade hiasan Natal asli Indonesia.\n${url}`
      : `Check out ${name} from Holy Flowy 🎄✨\nHandmade Christmas decor from Indonesia.\n${url}`;

  const wa = `https://wa.me/?text=${encodeURIComponent(text)}`;
  const tg = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const tw = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {}
  };

  const Btn = ({ href, onClick, label, color, testid, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      data-testid={testid}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-medium transition-all hover:-translate-y-0.5 ${color}`}
    >
      {children}
      <span>{label}</span>
    </a>
  );

  return (
    <div className="mt-6 pt-6 border-t border-border/60">
      <div className="text-[11px] tracking-[0.3em] uppercase text-muted-foreground mb-3">
        {lang === "id" ? "Bagikan" : "Share"}
      </div>
      <div className="flex flex-wrap gap-2">
        <Btn href={wa} label="WhatsApp" testid="share-wa" color="bg-[#25D366] text-white hover:bg-[#1ebe5d]">
          <MessageCircle className="w-3.5 h-3.5" />
        </Btn>
        <Btn href={tg} label="Telegram" testid="share-tg" color="bg-[#229ED9] text-white hover:bg-[#1c89bb]">
          <Send className="w-3.5 h-3.5" />
        </Btn>
        <Btn href={fb} label="Facebook" testid="share-fb" color="bg-[#1877F2] text-white hover:bg-[#1466d3]">
          <span className="font-bold">f</span>
        </Btn>
        <Btn href={tw} label="X / Twitter" testid="share-tw" color="bg-black text-white hover:bg-neutral-800">
          <span className="font-bold">𝕏</span>
        </Btn>
        <button
          onClick={copy}
          data-testid="share-copy"
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-medium transition-all hover:-translate-y-0.5 ${copied ? "bg-holy-green text-ivory" : "bg-cream text-foreground hover:bg-border"}`}
        >
          {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
          {copied ? (lang === "id" ? "Tersalin!" : "Copied!") : (lang === "id" ? "Salin Link" : "Copy Link")}
        </button>
      </div>
      {settings?.whatsapp && (
        <a
          href={`https://wa.me/${settings.whatsapp.replace(/[^\d]/g, "")}?text=${encodeURIComponent(lang === "id" ? `Halo Holy Flowy! Saya tertarik dengan ${name}. Bisa info lebih lanjut?` : `Hi Holy Flowy! I'm interested in ${name}. Can you share more info?`)}`}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-shop-wa"
          className="mt-4 inline-flex items-center gap-2 text-sm text-holy-green font-medium hover:underline"
        >
          <MessageCircle className="w-4 h-4" />
          {lang === "id" ? "Tanya tentang produk ini" : "Ask about this product"}
        </a>
      )}
    </div>
  );
};

export default ShareButtons;
